export default __webpack_public_path__ + "static/media/MultimeterIcon.2c7168a9.svg";